export default {
    PtProduct: { switch: 'Products', mainPage: 'Homepage' },
    PtHeader_products: {
        products: 'Products',
        workspace: 'Workspace',
        marketPlace: 'Marketplace',
        analytics: 'Analytics',
        insights: 'Insights',
        bio: 'Bio',
        chemical: 'Chemical',
        cas: 'CAS',
        discovery: 'Discovery',
        synapse: 'Synapse',
        academy: 'Academy',
        course: 'Academy',
        course2b: 'Course',
        lab: 'PatSnap Lab',
        open: 'Open Platform',
        ipAsset: 'IP Asset',
        allProducts: 'Products',
        tffi: 'TFFI',
        eureka: 'Eureka',
        pharmsnap: 'PharmSnap',
        yunchuang: 'Inno SaaS',
        innoCloud: 'INNOSNAP',
    },
};
